import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { Reference } from "@services/api/reference/reference.types";
import useReference from "./reference.hook";

type Result = {
  references: Reference[];
};

interface UseReferencesProps {
  type?: string;
  yearExternalId?: string;
  visibleExternalIds?: string[];
}

export function useReferences({
  type,
  yearExternalId,
  visibleExternalIds
}: UseReferencesProps): Result {
  const { getActiveReferences } = useReference();

  const { data = [] } = useQuery({
    queryKey: [type, yearExternalId],
    queryFn: () => getActiveReferences(type, yearExternalId),
    enabled: !!type && !!yearExternalId
  });

  const filteredReferences = useMemo(() => {
    const visibleReferences = data?.filter((ref) => ref.visible !== false);
    if (!visibleExternalIds) {
      return visibleReferences;
    }
    return visibleReferences.filter((ref) =>
      visibleExternalIds.includes(ref.externalId)
    );
  }, [data, visibleExternalIds]);

  return { references: filteredReferences };
}
